import { DataModel, SerializedData } from '../../dto/data-model.js';
import { AuditLogEntryType } from './audit-log-entry-type.js';

export abstract class AuditLogEntry extends DataModel {
  abstract generateQueryData(): SerializedData;
  abstract get type(): AuditLogEntryType;
}
